/**
 * @file  App.tsx
 * @description  Application entry point markup script
 *
 * @author ogarcia (ozkary)
 */
import React, { Suspense, useEffect, useCallback } from 'react';
import './content/app.scss';

import Footer from './components/Footer';
import Header from './components/Header';
import Layout from './elements/Layout';
import EditionRouter from './routes/loader';
import { LayoutBackTop } from './elements/LayoutBackTop';
import Loading from './components/Loading';
import AuditTracker from './components/AuditTracker';
import { loadSettings } from './services/settings';
import { signIn } from './functions/auth';

const App = (): JSX.Element => {
  /**
   * loads the auth token and settings
   */
  const initialize = useCallback(async () => {
    await signIn();
    await loadSettings();
  }, []);

  // initialize app dependencies
  useEffect(() => {
    initialize();
  }, []);

  return (
    <Layout className="app">
      <AuditTracker />
      <LayoutBackTop />
      <Suspense fallback={<Loading />}>
        <Layout.Header>
          <Header />
        </Layout.Header>
        <Layout.Content>
          <EditionRouter />
        </Layout.Content>
        <Layout.Footer>
          <Footer />
        </Layout.Footer>
      </Suspense>
    </Layout>
  );
};

export default App;
